export default __webpack_public_path__ + "assets/hr-video-placeholder.ebac0946.jpg";